
import LocationsAllContainer from '@/components/locations/all/views/Default.vue'
export default {
  name: 'LocationsAllPage',
  components: {
    LocationsAllContainer
  },
  head() {
    return this.$utils.head(this.story)
  },
  data() {
    return {
      story: {
        name: 'All Locations'
      }
    }
  }
}
